/**
 *
 * @returns {'eligibility' | 'qualify' | 'qualify-oneclick' | 'qualify-subone' | 'getting-started' | 'savings-estimates' | 'sub-one-new-stack' | 'unknown' | 'savings-estimates-static' | 'savings-estimates-static-variant-a' | 'savings-estimates-static-variant-b' | 'savings-estimates-static-variant-c' | 'ps-softpull' | 'onboarding' | 'onboarding-alt' | 'onboarding-savings' | 'onboarding-savings-v2' | 'onboarding-savings-v3'}
 */
export function getFunnelFromUrl() {
  const url = window.location.href
  if (/eligibility/.test(url)) {
    return 'eligibility'
  }

  if (/qualify\/one-click/.test(url)) {
    return 'qualify-oneclick'
  }

  if (/qualify\/sub-one/.test(url)) {
    return 'qualify-subone'
  }

  if (/qualify/.test(url)) {
    return 'qualify'
  }

  if (/\/savings-estimates\/submit/i.test(url)) {
    return 'savings-estimates-static'
  }

  if (/\/savings-estimates-a\/submit/i.test(url)) {
    return 'savings-estimates-static-variant-a'
  }

  if (/\/savings-estimates-b\/submit/i.test(url)) {
    return 'savings-estimates-static-variant-b'
  }

  if (/\/savings-estimates-c\/submit/i.test(url)) {
    return 'savings-estimates-static-variant-c'
  }

  if (/\/savings-estimates/i.test(url)) {
    return 'savings-estimates'
  }

  if (/\/sub-one/i.test(url)) {
    return 'sub-one-new-stack'
  }

  if (/\/personalized-savings/i.test(url)) {
    return 'ps-softpull'
  }

  if (/\/onboarding\/alt/i.test(url)) {
    return 'onboarding-alt'
  }

  if (/\/onboarding\/savings-v2/i.test(url)) {
    return 'onboarding-savings-v2'
  }

  if (/\/onboarding\/savings-v3/i.test(url)) {
    return 'onboarding-savings-v3'
  }

  if (/\/onboarding\/savings/i.test(url)) {
    return 'onboarding-savings'
  }

  if (/\/onboarding/i.test(url)) {
    return 'onboarding'
  }

  if (/\/getting-started/i.test(url)) {
    return 'getting-started'
  }

  return 'unknown'
}
